import React from 'react';
import theme from './theme';
import { ThemeProvider } from '@material-ui/styles';
// import Routes from '../src/Routes';
import Content from '../src/components/Content/Content';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './api';
import '../src/assets/index.scss';
import { check_validity } from './api/API';
import { useLocation } from 'react-router-dom';

import CreateAdmin from '../src/pages/CreateAdmin/CreateAdmin';

export default function App() {
    setInterval(() => {
        var location = window.location.href;

        if(location.indexOf("forgotpassword") > -1){
            return;
        }else if(location.indexOf("resetpassword")> -1){
            return;
        }
        check_validity();
    }, 5000);
    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <Content />
            </ThemeProvider>
        </BrowserRouter>
    )
}
